<div cdkDrag>
    <div class="modal-header cursor-all-scroll" cdkDragHandle>

        <div class="lbl_header">
            <fa name="fa fa-arrows"></fa>
            <h5 class="modal-title pull-left pl-3">Drag and Drop Using This Header</h5>
        </div>

        <div class="btn_header">
            <div aria-label="Close" class="cursor-pointer pr-3">
                <fa name="fa fa-thumb-tack"></fa>
            </div>
            <div aria-label="Close" class="cursor-pointer" (click)="onCancel()">
                <fa name="fa fa-times"></fa>
            </div>

        </div>
    </div>

    <div class="modal-body">
        <div class="alert-danger" *ngIf="errMsg">
            {{errMsg}}
        </div>
        <div class="row mb-4">
            <div class="col-sm-12">
                <h4 class="modal-title pull-left">Report an issue</h4>
            </div>
        </div>
        <!-- Loader -->
        <loader [ngClass]="{ 'overlay_loader': loading}" [loading]="loading"></loader>
        <div class="row">

            <div class="col-sm-12">
                
                <div class="form-group">
                    <label class="rbv-label">Subject</label>
                    <input type="text" [(ngModel)]="reportedIssue.SUBJECT" placeholder="Subject"
                        class="form-control rounded-0" name="subject" autocomplete="off" autofocus="autofocus" />
                </div>
                <div class="form-group">
                    <label class="rbv-label">Issue Type</label>
                    <input-search [inputValue]="reportedIssue.ISSUE_TYPE" placeholder="Type"
                        [itemsHeader]="'Search Results'" (valueChange)="issueTypeSelected($event)"
                        [preset]="issueTypeValues"></input-search>
                </div>

                <div class="form-group">
                    <label class="rbv-label">Describe the issue</label>
                    <div class="content-wrapper">
                        <textarea name="description" placeholder="Enter Description Here..."
                            [(ngModel)]="reportedIssue.DESCRIPTION" class="form-control rounded-0" rows="6"
                            style="resize: none;"></textarea>
                    </div>
                </div>
                <div class="form-group">
                    <label class="rbv-label">Attach a photo or a file: </label>
                    <div *ngIf="files.length>0" class="attach_files_container">
                        <div *ngFor="let f of files;let i = index" class="attach_files">
                            <div class="cursor-pointer" (click)="onRemove(i)">
                                <fa name="fa fa-trash"></fa>
                            </div>
                            <img [src]="f.thumbnail " alt="....">
                        </div>


                    </div>

                    <div class="custom-dropzone drag_outer" ngx-dropzone [accept]="'*'" [multiple]="true"
                        (change)="onSelect($event)">
                        <ngx-dropzone-label>
                            <div class="drag_and_drop_col">
                                <img src="assets/images/folder.svg" draggable="false" alt="folder">
                                <div>
                                    <h6>Drag & Drop File here </h6>
                                    <label>Or Select a File</label>
                                </div>
                            </div>
                        </ngx-dropzone-label>

                    </div>



                </div>

                <button class="btn btn-rbv  btn_report" [disabled]="loading" (click)="onConfirm()">Send Report</button>

            </div>
        </div>
    </div>
</div>